import React, { useEffect } from 'react';
// import logo from '../assets/images/afterimagelabs_logo.jpeg'; // No longer needed

// Minimal version (was the previous Home)
export const MinimalHome = () => {
  useEffect(() => {
    document.title = 'Afterimage';
    const originalBackground = document.body.style.backgroundColor;
    document.body.style.backgroundColor = 'white';
    const originalBodyStyle = {
      margin: document.body.style.margin,
      padding: document.body.style.padding,
      overflow: document.body.style.overflow
    };
    document.body.style.margin = '0';
    document.body.style.padding = '0';
    document.body.style.overflow = 'hidden';
    return () => {
      document.body.style.backgroundColor = originalBackground;
      document.body.style.margin = originalBodyStyle.margin;
      document.body.style.padding = originalBodyStyle.padding;
      document.body.style.overflow = originalBodyStyle.overflow;
    };
  }, []);
  return (
    <div style={{ 
      width: '100vw', 
      height: '100vh',
      backgroundColor: 'white',
      position: 'fixed',
      top: 0,
      left: 0,
      right: 0,
      bottom: 0,
      zIndex: 9999,
      margin: 0,
      padding: 0,
      border: 'none',
      outline: 'none',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      textAlign: 'center'
    }}>
      <p style={{
        fontSize: '1.5rem',
        lineHeight: '1.6',
        maxWidth: '1000px',
        padding: '0 2rem',
        color: '#333'
      }}>
        We're fixing healthcare by rewiring the infrastructure of safety and accountability.
        <br />
        We use technology to change incentives and save lives.
      </p>
    </div>
  );
};

// SVG Logo Component
const AfterimageLogo = () => (
  <div style={{textAlign: 'center', marginBottom: '2.5rem'}}>
    <svg
      width="180"
      height="120"
      viewBox="0 0 200 120"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      style={{display: 'block', margin: '0 auto'}}
    >
      <defs>
        <linearGradient id="eyeGradient" x1="0%" y1="50%" x2="100%" y2="50%">
          <stop offset="0%" stopColor="#AA5B52" />
          <stop offset="65%" stopColor="#AA5B52" />
          <stop offset="85%" stopColor="#AA5B52" stopOpacity="0.3" />
          <stop offset="100%" stopColor="#AA5B52" stopOpacity="0" />
        </linearGradient>
        <linearGradient id="textGradient" x1="0%" y1="0%" x2="100%" y2="0%">
          <stop offset="0%" stopColor="#2D2D2D" />
          <stop offset="50%" stopColor="#AA5B52" />
        </linearGradient>
        <filter id="glow">
          <feGaussianBlur stdDeviation="2" result="coloredBlur"/>
          <feMerge>
            <feMergeNode in="coloredBlur"/>
            <feMergeNode in="SourceGraphic"/>
          </feMerge>
        </filter>
        <linearGradient id="glintGradient" x1="50%" y1="0%" x2="50%" y2="100%">
          <stop offset="0%" stopColor="white" stopOpacity="0.6" />
          <stop offset="100%" stopColor="white" stopOpacity="0" />
        </linearGradient>
      </defs>
      {/* Eye shape */}
      <path
        d="M20 60 C20 60, 100 -15, 180 60 C180 60, 100 135, 20 60"
        stroke="url(#eyeGradient)"
        strokeWidth="10"
        fill="none"
        strokeLinecap="round"
      />
      {/* Magnifying glass with glow */}
      <g filter="url(#glow)">
        {/* Magnifying glass circle */}
        <circle
          cx="100"
          cy="60"
          r="20"
          stroke="#AA5B52"
          strokeWidth="10"
          fill="white"
        />
        {/* Handle - positioned at bottom-left arc */}
        <path
          d="M86 74 L55 105"
          stroke="#AA5B52"
          strokeWidth="10"
          strokeLinecap="round"
        />
        {/* Plus sign */}
        <path
          d="M100 52 L100 68 M92 60 L108 60"
          stroke="#AA5B52"
          strokeWidth="5"
          strokeLinecap="round"
        />
      </g>
      {/* Glint effects */}
      <path
        d="M90 45 A20 20 0 0 1 110 45"
        stroke="url(#glintGradient)"
        strokeWidth="4"
        fill="none"
        strokeLinecap="round"
      />
      {/* Additional subtle glow around magnifying glass */}
      <circle
        cx="100"
        cy="60"
        r="24"
        stroke="#AA5B52"
        strokeWidth="1"
        strokeOpacity="0.3"
        fill="none"
      />
      <circle
        cx="100"
        cy="60"
        r="26"
        stroke="#AA5B52"
        strokeWidth="0.5"
        strokeOpacity="0.2"
        fill="none"
      />
    </svg>
    <div style={{marginTop: '1rem'}}>
      <div style={{
        fontFamily: 'Inter, sans-serif',
        fontWeight: 800,
        fontSize: '2rem',
        letterSpacing: '0.02em',
        display: 'inline-block',
      }}>
        <span style={{color: '#AA5B52'}}>AFTER</span>
        <span style={{
          background: 'linear-gradient(90deg, #AA5B52 0%, #2D2D2D 100%)',
          WebkitBackgroundClip: 'text',
          WebkitTextFillColor: 'transparent',
        }}>IMAGE</span>
      </div>
      <span style={{
        display: 'block',
        fontFamily: 'Inter, sans-serif',
        fontWeight: 500,
        fontSize: '1rem',
        background: 'linear-gradient(90deg, #AA5B52 30%, #2D2D2D 100%)',
        WebkitBackgroundClip: 'text',
        WebkitTextFillColor: 'transparent',
        marginTop: '0.2rem',
        letterSpacing: '0.15em',
      }}>
        Labs
      </span>
    </div>
  </div>
);

// New, more substantial Home page focused on healthcare democratization
const Home = () => {
  useEffect(() => {
    document.title = 'Afterimage - Democratizing Healthcare Access & Medical Justice';
    document.body.style.backgroundColor = '#FFF8F5';
    return () => {
      document.body.style.backgroundColor = '';
    };
  }, []);

  return (
    <main>
      {/* Hero Section */}
      <section style={{
        background: 'linear-gradient(135deg, #fff8f5 0%, #f7e6e1 50%, #e8f4f8 100%)',
        padding: '7rem 0 5rem 0',
        textAlign: 'center',
        boxShadow: '0 5px 30px rgba(170,91,82,0.07)',
        position: 'relative',
        overflow: 'hidden'
      }}>
        {/* Background pattern */}
        <div style={{
          position: 'absolute',
          top: 0,
          left: 0,
          right: 0,
          bottom: 0,
          opacity: 0.03,
          backgroundImage: `url("data:image/svg+xml,%3Csvg width='60' height='60' viewBox='0 0 60 60' xmlns='http://www.w3.org/2000/svg'%3E%3Cg fill='none' fill-rule='evenodd'%3E%3Cg fill='%23AA5B52' fill-opacity='1'%3E%3Ccircle cx='30' cy='30' r='2'/%3E%3C/g%3E%3C/g%3E%3C/svg%3E")`,
        }}></div>
        <div className="container" style={{maxWidth: 1000, margin: '0 auto', position: 'relative', zIndex: 1, padding: '0 1rem', width: '100%', boxSizing: 'border-box'}}>
          <AfterimageLogo />
          <h1 style={{
            fontSize: 'clamp(2.5rem, 5vw, 4rem)', 
            fontWeight: 800, 
            marginBottom: '2rem', 
            background: 'linear-gradient(135deg, #AA5B52 0%, #2D5B7B 100%)',
            WebkitBackgroundClip: 'text',
            WebkitTextFillColor: 'transparent',
            letterSpacing: '-0.03em',
            lineHeight: 1.2,
            padding: '0 1rem'
          }}>
            Democratizing Access to<br/>Quality Healthcare
          </h1>
          <p style={{
            fontSize: 'clamp(1.1rem, 3vw, 1.6rem)', 
            color: '#333', 
            marginBottom: '1.5rem', 
            lineHeight: 1.6,
            maxWidth: '800px',
            margin: '0 auto 1.5rem auto',
            padding: '0 1rem'
          }}>
            Breaking down barriers to medical justice through technology, transparency, and systemic safety guardrails.
          </p>
          <p style={{
            fontSize: 'clamp(1rem, 2.5vw, 1.2rem)', 
            color: '#666', 
            marginBottom: '3rem', 
            lineHeight: 1.6,
            maxWidth: '700px',
            margin: '0 auto 3rem auto',
            padding: '0 1rem'
          }}>
            We're building infrastructure that makes quality healthcare accessible to everyone, while creating accountability systems that protect patients and improve outcomes.
          </p>
          <div style={{display: 'flex', justifyContent: 'center', gap: '1rem', flexWrap: 'wrap', padding: '0 1rem'}}>
            <a href="/mission" className="btn btn-primary" style={{
              fontSize: 'clamp(1rem, 2.5vw, 1.2rem)', 
              padding: 'clamp(1rem, 2.5vw, 1.2rem) clamp(1.5rem, 4vw, 2.8rem)', 
              borderRadius: '3rem', 
              background: 'linear-gradient(135deg, #AA5B52 0%, #8B4A42 100%)', 
              color: 'white', 
              fontWeight: 700, 
              textDecoration: 'none',
              boxShadow: '0 4px 15px rgba(170,91,82,0.3)',
              transition: 'transform 0.2s ease',
              minWidth: '140px',
              textAlign: 'center'
            }}>Our Mission</a>
            <a href="/impact" className="btn btn-secondary" style={{
              fontSize: 'clamp(1rem, 2.5vw, 1.2rem)', 
              padding: 'clamp(1rem, 2.5vw, 1.2rem) clamp(1.5rem, 4vw, 2.8rem)', 
              borderRadius: '3rem', 
              background: '#fff', 
              color: '#AA5B52', 
              border: '2px solid #AA5B52', 
              fontWeight: 700, 
              textDecoration: 'none',
              boxShadow: '0 4px 15px rgba(170,91,82,0.1)',
              transition: 'transform 0.2s ease',
              minWidth: '140px',
              textAlign: 'center'
            }}>Our Impact</a>
          </div>
        </div>
      </section>

      {/* Core Pillars Section */}
      <section style={{padding: '6rem 0', background: 'white', position: 'relative'}}>
        <div className="container" style={{maxWidth: 1200, margin: '0 auto', padding: '0 1rem', width: '100%', boxSizing: 'border-box'}}>
          <div style={{textAlign: 'center', marginBottom: '4rem'}}>
            <h2 style={{
              fontSize: 'clamp(2rem, 4vw, 3rem)', 
              fontWeight: 700, 
              marginBottom: '1.5rem', 
              color: '#AA5B52'
            }}>Our Core Pillars</h2>
            <p style={{
              fontSize: 'clamp(1rem, 2.5vw, 1.3rem)', 
              color: '#666', 
              maxWidth: '700px', 
              margin: '0 auto',
              lineHeight: 1.6,
              padding: '0 1rem'
            }}>
              Three fundamental principles guide our approach to transforming healthcare
            </p>
          </div>
          
          <div style={{display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(280px, 1fr))', gap: '2rem', alignItems: 'stretch', padding: '0 1rem'}}>
            {/* Democratizing Access */}
            <div style={{
              background: 'linear-gradient(135deg, #f0f9ff 0%, #e0f2fe 100%)', 
              borderRadius: '2rem', 
              padding: '3rem 2.5rem', 
              textAlign: 'center',
              border: '1px solid #e3f2fd',
              boxShadow: '0 8px 25px rgba(45,91,123,0.08)',
              position: 'relative',
              overflow: 'hidden'
            }}>
              <div style={{
                fontSize: '4rem', 
                marginBottom: '1.5rem',
                background: 'linear-gradient(135deg, #2D5B7B 0%, #1976d2 100%)',
                WebkitBackgroundClip: 'text',
                WebkitTextFillColor: 'transparent'
              }}>🌍</div>
              <h3 style={{
                fontWeight: 700, 
                color: '#2D5B7B', 
                marginBottom: '1.5rem',
                fontSize: '1.5rem'
              }}>Democratizing Access</h3>
              <p style={{color: '#444', lineHeight: 1.7, fontSize: '1.1rem'}}>
                Breaking down financial, geographic, and systemic barriers that prevent people from getting the healthcare they need. We believe quality medical care should be a right, not a privilege.
              </p>
            </div>

            {/* Medical Justice */}
            <div style={{
              background: 'linear-gradient(135deg, #fff8e1 0%, #fff3c4 100%)', 
              borderRadius: '2rem', 
              padding: '3rem 2.5rem', 
              textAlign: 'center',
              border: '1px solid #ffe082',
              boxShadow: '0 8px 25px rgba(255,193,7,0.08)',
              position: 'relative',
              overflow: 'hidden'
            }}>
              <div style={{
                fontSize: '4rem', 
                marginBottom: '1.5rem',
                background: 'linear-gradient(135deg, #f57c00 0%, #ff9800 100%)',
                WebkitBackgroundClip: 'text',
                WebkitTextFillColor: 'transparent'
              }}>⚖️</div>
              <h3 style={{
                fontWeight: 700, 
                color: '#f57c00', 
                marginBottom: '1.5rem',
                fontSize: '1.5rem'
              }}>Medical Justice</h3>
              <p style={{color: '#444', lineHeight: 1.7, fontSize: '1.1rem'}}>
                Ensuring accountability, transparency, and fairness in healthcare delivery. Every patient deserves equal treatment and the right to understand their care decisions.
              </p>
            </div>

            {/* Safety Guardrails */}
            <div style={{
              background: 'linear-gradient(135deg, #f3e5f5 0%, #e8eaf6 100%)', 
              borderRadius: '2rem', 
              padding: '3rem 2.5rem', 
              textAlign: 'center',
              border: '1px solid #d1c4e9',
              boxShadow: '0 8px 25px rgba(170,91,82,0.08)',
              position: 'relative',
              overflow: 'hidden'
            }}>
              <div style={{
                fontSize: '4rem', 
                marginBottom: '1.5rem',
                background: 'linear-gradient(135deg, #AA5B52 0%, #7b1fa2 100%)',
                WebkitBackgroundClip: 'text',
                WebkitTextFillColor: 'transparent'
              }}>🛡️</div>
              <h3 style={{
                fontWeight: 700, 
                color: '#AA5B52', 
                marginBottom: '1.5rem',
                fontSize: '1.5rem'
              }}>Safety Guardrails</h3>
              <p style={{color: '#444', lineHeight: 1.7, fontSize: '1.1rem'}}>
                Building systematic protections that prevent medical errors, improve diagnostic accuracy, and create continuous feedback loops for better patient outcomes.
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* How We Work Section */}
      <section style={{padding: '6rem 0', background: 'linear-gradient(135deg, #fafafa 0%, #f5f5f5 100%)'}}>
        <div className="container" style={{maxWidth: 1000, margin: '0 auto', padding: '0 1rem', width: '100%', boxSizing: 'border-box'}}>
          <div style={{textAlign: 'center', marginBottom: '4rem'}}>
            <h2 style={{
              fontSize: 'clamp(2rem, 4vw, 2.8rem)', 
              fontWeight: 700, 
              marginBottom: '1.5rem', 
              color: '#AA5B52'
            }}>How We're Making Change</h2>
            <p style={{
              fontSize: 'clamp(1rem, 2.5vw, 1.2rem)', 
              color: '#666', 
              maxWidth: '800px', 
              margin: '0 auto',
              lineHeight: 1.6,
              padding: '0 1rem'
            }}>
              Through technology, advocacy, and systemic reform, we're creating a healthcare system that works for everyone
            </p>
          </div>
          
          <div style={{display: 'flex', flexWrap: 'wrap', gap: '2.5rem', justifyContent: 'center'}}>
            <div style={{
              flex: '1 1 280px', 
              background: 'white', 
              borderRadius: '1.5rem', 
              padding: '2.5rem', 
              minWidth: 280, 
              maxWidth: 350,
              boxShadow: '0 8px 25px rgba(0,0,0,0.06)',
              border: '1px solid #f0f0f0'
            }}>
              <div style={{
                width: '60px', 
                height: '60px', 
                background: 'linear-gradient(135deg, #e3f2fd 0%, #bbdefb 100%)', 
                borderRadius: '50%', 
                display: 'flex', 
                alignItems: 'center', 
                justifyContent: 'center', 
                marginBottom: '1.5rem',
                fontSize: '1.8rem'
              }}>🔬</div>
              <h3 style={{fontWeight: 700, color: '#2D5B7B', marginBottom: '1rem', fontSize: '1.3rem'}}>Technology Innovation</h3>
              <p style={{color: '#555', lineHeight: 1.6}}>
                Building AI-powered diagnostic tools and platforms that improve accuracy while reducing costs and barriers to access.
              </p>
            </div>

            <div style={{
              flex: '1 1 280px', 
              background: 'white', 
              borderRadius: '1.5rem', 
              padding: '2.5rem', 
              minWidth: 280, 
              maxWidth: 350,
              boxShadow: '0 8px 25px rgba(0,0,0,0.06)',
              border: '1px solid #f0f0f0'
            }}>
              <div style={{
                width: '60px', 
                height: '60px', 
                background: 'linear-gradient(135deg, #fff3e0 0%, #ffe0b2 100%)', 
                borderRadius: '50%', 
                display: 'flex', 
                alignItems: 'center', 
                justifyContent: 'center', 
                marginBottom: '1.5rem',
                fontSize: '1.8rem'
              }}>📊</div>
              <h3 style={{fontWeight: 700, color: '#f57c00', marginBottom: '1rem', fontSize: '1.3rem'}}>Data Transparency</h3>
              <p style={{color: '#555', lineHeight: 1.6}}>
                Creating open systems that give patients access to their health information and enable informed decision-making.
              </p>
            </div>

            <div style={{
              flex: '1 1 280px', 
              background: 'white', 
              borderRadius: '1.5rem', 
              padding: '2.5rem', 
              minWidth: 280, 
              maxWidth: 350,
              boxShadow: '0 8px 25px rgba(0,0,0,0.06)',
              border: '1px solid #f0f0f0'
            }}>
              <div style={{
                width: '60px', 
                height: '60px', 
                background: 'linear-gradient(135deg, #fce4ec 0%, #f8bbd9 100%)', 
                borderRadius: '50%', 
                display: 'flex', 
                alignItems: 'center', 
                justifyContent: 'center', 
                marginBottom: '1.5rem',
                fontSize: '1.8rem'
              }}>🤝</div>
              <h3 style={{fontWeight: 700, color: '#AA5B52', marginBottom: '1rem', fontSize: '1.3rem'}}>Community Advocacy</h3>
              <p style={{color: '#555', lineHeight: 1.6}}>
                Empowering patients and providers with resources, education, and support networks to advocate for better care.
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* Call to Action Section */}
      <section style={{
        padding: '5rem 0 6rem 0', 
        background: 'linear-gradient(135deg, #AA5B52 0%, #8B4A42 100%)', 
        textAlign: 'center',
        color: 'white'
      }}>
        <div className="container" style={{maxWidth: 800, margin: '0 auto', padding: '0 1rem', width: '100%', boxSizing: 'border-box'}}>
          <h2 style={{
            fontSize: 'clamp(2rem, 4vw, 2.5rem)', 
            fontWeight: 700, 
            color: 'white', 
            marginBottom: '1.5rem'
          }}>Join the Movement</h2>
          <p style={{
            fontSize: 'clamp(1rem, 2.5vw, 1.3rem)', 
            color: 'rgba(255,255,255,0.9)', 
            marginBottom: '3rem',
            lineHeight: 1.6,
            padding: '0 1rem'
          }}>
            Whether you're a patient, provider, researcher, or advocate, there's a place for you in building a more just and accessible healthcare system.
          </p>
          <div style={{display: 'flex', justifyContent: 'center', gap: '1rem', flexWrap: 'wrap', padding: '0 1rem'}}>
            <a href="/team" className="btn btn-secondary" style={{
              fontSize: 'clamp(1rem, 2.5vw, 1.2rem)', 
              padding: 'clamp(1rem, 2.5vw, 1.2rem) clamp(1.5rem, 4vw, 2.5rem)', 
              borderRadius: '3rem', 
              background: 'white', 
              color: '#AA5B52', 
              fontWeight: 700, 
              textDecoration: 'none',
              boxShadow: '0 4px 15px rgba(0,0,0,0.1)',
              transition: 'transform 0.2s ease',
              minWidth: '140px',
              textAlign: 'center'
            }}>Meet Our Team</a>
            <a href="/careers" className="btn btn-primary" style={{
              fontSize: 'clamp(1rem, 2.5vw, 1.2rem)', 
              padding: 'clamp(1rem, 2.5vw, 1.2rem) clamp(1.5rem, 4vw, 2.5rem)', 
              borderRadius: '3rem', 
              background: 'transparent', 
              color: 'white', 
              border: '2px solid white', 
              fontWeight: 700, 
              textDecoration: 'none',
              transition: 'transform 0.2s ease',
              minWidth: '140px',
              textAlign: 'center'
            }}>Get Involved</a>
          </div>
        </div>
      </section>
    </main>
  );
};

export default Home; 